import React, { memo, useCallback, Fragment } from 'react';
import PropTypes from 'prop-types';
import ViewConsent from './ViewConsent';

import styles from './index.styl';

const RenderViewConsents = ({ consentsList, formatMessage }) => {
  const renderViewConsents = useCallback(
    (consents, params) => {
      const rulesMap = index =>
        params === 'even' ? index % 2 === 0 : index % 2 !== 0;

      return (
        consents.length > 0 &&
        consents.map(
          (
            {
              id,
              name,
              status,
              fileUrl,
              version,
              program,
              expiresAt,
              consentType,
              statusChangedAt,
              consentAssignmentId,
              consentAssignmentType,
            },
            index,
          ) => {
            const { programName } = { ...program };
            const { name: consentTypeTitle = 'Uncategorized' } = {
              ...consentType,
            };

            return (
              rulesMap(index) && (
                <Fragment key={consentAssignmentId}>
                  <ViewConsent
                    key={id}
                    name={name}
                    status={status}
                    fileUrl={fileUrl}
                    version={version}
                    expiresAt={expiresAt}
                    programName={programName}
                    formatMessage={formatMessage}
                    statusChangedAt={statusChangedAt}
                    consentTypeTitle={consentTypeTitle}
                    consentAssignmentType={consentAssignmentType}
                  />
                </Fragment>
              )
            );
          },
        )
      );
    },
    [consentsList],
  );

  return (
    <div className={styles.consentsWrapper}>
      <div className={styles.column}>
        {renderViewConsents(consentsList, 'even')}
      </div>
      <div className={styles.column}>
        {renderViewConsents(consentsList, 'odd')}
      </div>
    </div>
  );
};

RenderViewConsents.propTypes = {
  consentsList: PropTypes.array,
  formatMessage: PropTypes.func,
};

export default memo(RenderViewConsents);



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/ProfileDocumentation/RenderViewConsents/index.jsx